import { render, staticRenderFns } from "./CatalogueDetails.vue?vue&type=template&id=77e48d3a&scoped=true&"
import script from "./CatalogueDetails.vue?vue&type=script&lang=js&"
export * from "./CatalogueDetails.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueDetails.vue?vue&type=style&index=0&id=77e48d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e48d3a",
  null
  
)

export default component.exports